import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Paper,
  Grid,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import RefreshIcon from "@mui/icons-material/Refresh";

const FormStatsDateFilter = ({
  periodType,
  startDate,
  endDate,
  onPeriodTypeChange,
  onStartDateChange,
  onEndDateChange,
  onApplyFilters,
  onRefresh,
}) => {
  const formatDateForInput = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (value, setter) => {
    if (!value) {
      setter(null);
      return;
    }

    // Parser la date de manière explicite pour éviter les problèmes de fuseau horaire
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(year, month - 1, day); // month - 1 car les mois JS commencent à 0
    setter(date);
  };

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel id="period-type-label">Période</InputLabel>
            <Select
              labelId="period-type-label"
              id="period-type"
              value={periodType}
              label="Période"
              onChange={(e) => onPeriodTypeChange(e.target.value)}
            >
              <MenuItem value="7days">7 derniers jours</MenuItem>
              <MenuItem value="30days">30 derniers jours</MenuItem>
              <MenuItem value="3months">3 derniers mois</MenuItem>
              <MenuItem value="year">Dernière année</MenuItem>
              <MenuItem value="custom">Personnalisé</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Date de début"
            type="date"
            value={formatDateForInput(startDate)}
            onChange={(e) =>
              handleDateChange(e.target.value, onStartDateChange)
            }
            InputLabelProps={{
              shrink: true,
            }}
            disabled={periodType !== "custom"}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Date de fin"
            type="date"
            value={formatDateForInput(endDate)}
            onChange={(e) => handleDateChange(e.target.value, onEndDateChange)}
            InputLabelProps={{
              shrink: true,
            }}
            disabled={periodType !== "custom"}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<FilterListIcon />}
              onClick={onApplyFilters}
              sx={{ textTransform: "none" }}
            >
              Appliquer
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={onRefresh}
              sx={{ minWidth: "auto", px: 2 }}
            >
              <RefreshIcon />
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FormStatsDateFilter;
